import { type ReactNode, useCallback, useState } from 'react';

export const useConstructorEditCustomSection = ({
    renderCustomSectionModal,
}: {
    renderCustomSectionModal: ({
        isOpen,
        onClose,
        templateId,
    }: {
        isOpen: boolean;
        onClose: VoidFunction;
        templateId: string;
    }) => ReactNode;
}) => {
    const [templateId, setTemplateId] = useState('');

    const editCustomSection = useCallback((templateId: string) => {
        setTemplateId(templateId);
    }, []);

    return {
        editCustomSection,
        renderModal: () =>
            renderCustomSectionModal({ isOpen: Boolean(templateId), onClose: () => setTemplateId(''), templateId }),
    };
};
